import { useState } from 'react';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, Alert, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// components
import Iconify from '../../components/iconify';
import FormProvider, { RHFTextField } from '../../components/hook-form';

// ----------------------------------------------------------------------

export default function AuthRegisterForm() {
  const navigate = useNavigate();
  const { register } = useAuthContext();

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    key: Yup.string().required('Ключ обовʼязковий').matches(/^[a-z0-9]+$/gi , 'Дозволено лише латинські літери та цифри'),
    name: Yup.string().required('Імʼя обоʼязкое'),
    email: Yup.string().email('Некорректний формат email').required('Email обоʼязковий'),
  });

  const defaultValues = {
    key: '',
    name: '',
    email: ''
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = methods;

  const onSubmit = async (data) => {
    try {
      await register(data.key, data.name, data.email);
      if(localStorage.getItem('accessToken')){
        navigate('/')
      }
    } catch (error) {
      console.error(error);

      //reset();

      setError('afterSubmit', {
        ...error,
        message: error.message || error,
      });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="name" label="Імʼя" />

        <RHFTextField name="email" label="Email" />

        <RHFTextField name="key" label="Ключ" helperText="Ваша назва латинськими літерами та цифрами" />

      <LoadingButton
        fullWidth
        color="info"
        size="large"
        type="submit"
        variant="contained"
        loading={isSubmitSuccessful || isSubmitting}
        sx={{
          bgcolor: 'text.primary',
          color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          '&:hover': {
            bgcolor: 'text.primary',
            color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          },
        }}
      >
        Зареєструватись
      </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
